function togglePasswordVisibility(toggleElement) {
  const showClassString = "show";
  const parent = toggleElement.parentNode;
  const input = parent.querySelector("[data-password-input]");
  const iconVisibility = toggleElement.querySelector(".icon-visibility");
  const iconVisibilityOff = toggleElement.querySelector(".icon-visibility-off");
  const showText = toggleElement.getAttribute("data-show-text");
  const hideText = toggleElement.getAttribute("data-hide-text");

  if (input.type === "password") {
    input.type = "text";
    iconVisibility.classList.remove(showClassString);
    iconVisibilityOff.classList.add(showClassString);
    toggleElement.setAttribute("aria-label", hideText);
    toggleElement.setAttribute("aria-pressed", "true");
  } else {
    input.type = "password";
    iconVisibilityOff.classList.remove(showClassString);
    iconVisibility.classList.add(showClassString);
    toggleElement.setAttribute("aria-label", showText);
    toggleElement.setAttribute("aria-pressed", "false");
  }
}
